export const RESIZE_WINDOW = 'RESIZE_WINDOW';

let initialState = {
  width: typeof window !== 'undefined' ? window.innerWidth : 1024,
  height: typeof window !== 'undefined' ? window.innerHeight : 768,
};

export const resizeWindow = () => {
  return {
    type: RESIZE_WINDOW,
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  };
};

const doResizeWindow = (state, action) => {
  return Object.assign({}, state, { width: action.width, height: action.height });
};

export default (state = initialState, action) => {
  switch (action.type) {
  case RESIZE_WINDOW:
    return doResizeWindow(state, action);
  default:
    return state;
  }
};
